export default __webpack_public_path__ + "static/N0110-4cec45b4cdfff38d36ee6c2afaf70564.png";